"use client";

import { CardListPagination } from "@widgets/card-list-pagination";
import { PageHero } from "@widgets/page-hero";

import { WebCamCard } from "@features/web-cam-card";
import { WebCamPopup } from "@features/web-cam-popup";

import { useFilterPaginationWithPopup } from "@shared/hooks/use-filter-pagination-with-popup";
import { Popup } from "@shared/ui/popup";

import { getCurrentWebCams } from "../api/getCurrentWebCams";
import type { WebCamsPageType, WebCamsType, WebCamTypesType } from "../model";

import s from "./web-cams-page.module.scss";

export type WebCamsPageProps = {
  filters: WebCamTypesType[];
  webCams: WebCamsType;
  pageData: WebCamsPageType;
};

export const WebCamsPage = (props: WebCamsPageProps) => {
  const { webCams, pageData } = props;

  const {
    currentContent,
    isOpenPopup,
    currentIndex,
    handleClosePopup,
    handleClickOnCard,
    handleClickOnNext,
    handleClickOnPrev,
    handleClickOnPagination,
  } = useFilterPaginationWithPopup({
    initialContent: webCams,
    fetchFunction: getCurrentWebCams,
  });

  return (
    <main className={s.root}>
      {pageData?.titleWithIcon && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={pageData.titleWithIcon}
          description={pageData.heroDescription}
        />
      )}
      <section className={s.content}>
        {currentContent.data.length > 0 && (
          <>
            <div className={s.cards}>
              {currentContent.data.map((cam, index) => (
                <WebCamCard
                  key={`web_cam-${cam.documentId}-${index + 1}`}
                  data={cam}
                  onCardClick={(uid) =>
                    handleClickOnCard(uid, (item) => item.uid)
                  }
                />
              ))}
            </div>
            {currentContent.meta.pagination.total > 4 && (
              <CardListPagination
                className={s.pagination}
                totalPages={currentContent.meta.pagination.pageCount}
                currentPageIndex={currentContent.meta.pagination.page}
                onNextClick={handleClickOnNext}
                onPrevClick={handleClickOnPrev}
                onPaginationClick={handleClickOnPagination}
              />
            )}
          </>
        )}
      </section>
      <Popup
        id="web-cam-popup"
        onClose={handleClosePopup}
        isOpen={isOpenPopup}
        variant="web-cam"
      >
        <WebCamPopup
          data={currentContent.data[currentIndex]}
          isOpen={isOpenPopup}
          onClose={handleClosePopup}
        />
      </Popup>
    </main>
  );
};

WebCamsPage.displayName = "WebCamsPage";
